import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../config/axios';
import { formatError } from '../utils/errorHandler';

function TaskChecklist({
  checklist,
  taskId,
  canCheckItems,
  taskStatus,
  onUpdated,
  onError
}) {
  const { t } = useTranslation(['tasks', 'common']);

  if (!checklist || checklist.length === 0) {
    return null;
  }

  const normalizedChecklist = checklist.map(item => {
    if (typeof item === 'string') {
      return { text: item, checked: false };
    }
    return {
      text: item.text || item,
      checked: item.checked || false
    };
  });

  const checkedCount = normalizedChecklist.filter(item => item.checked).length;

  return (
    <div className="task-detail-section">
      <h3 className="task-section-label">
        {t('tasks:checklistWithCount', { checked: checkedCount, total: normalizedChecklist.length })}
      </h3>
      <div className="task-checklist-horizontal">
        {normalizedChecklist.map((item, index) => (
          <label
            key={index}
            className={`task-checklist-item-horizontal ${item.checked ? 'checked' : ''} ${canCheckItems && taskStatus !== 'completed' ? 'task-checklist-item-horizontal--interactive' : 'task-checklist-item-horizontal--readonly'}`}
          >
            <input
              type="checkbox"
              checked={item.checked || taskStatus === 'completed'}
              disabled={!canCheckItems || taskStatus === 'completed'}
              onChange={async (e) => {
                if (canCheckItems && taskStatus !== 'completed') {
                  try {
                    await axios.put(`/api/tasks/${taskId}/checklist/${index}`, {
                      checked: e.target.checked
                    });
                    onUpdated();
                  } catch (error) {
                    console.error('Error updating checklist item:', error);
                    if (onError) {
                      onError(formatError(error) || t('tasks:failedUpdateChecklist'));
                    }
                  }
                }
              }}
            />
            <span>{item.text}</span>
          </label>
        ))}
      </div>
    </div>
  );
}

export default TaskChecklist;
